import * as React from "react"
import Svg, { Circle, Path } from "react-native-svg"

function UserInfo(props: any) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            {...props}
        >
            <Circle cx={20} cy={20} r={20} fill={props?.bg ?? "#EBF2FF"} />
            <Path
                d="M20 19.975c-1.1 0-2-.35-2.7-1.05-.7-.7-1.05-1.6-1.05-2.7s.35-2 1.05-2.7c.7-.7 1.6-1.05 2.7-1.05s2 .35 2.7 1.05c.7.7 1.05 1.6 1.05 2.7s-.35 2-1.05 2.7c-.7.7-1.6 1.05-2.7 1.05zM26.5 28h-13c-.417 0-.77-.146-1.063-.437A1.446 1.446 0 0112 26.5v-.85c0-.633.158-1.175.475-1.625A3.05 3.05 0 0113.7 23c1.117-.5 2.188-.875 3.213-1.125A12.987 12.987 0 0120 21.5c1.033 0 2.058.13 3.075.388 1.017.258 2.083.629 3.2 1.112.517.233.933.575 1.25 1.025.317.45.475.992.475 1.625v.85c0 .417-.146.77-.438 1.063A1.446 1.446 0 0126.5 28zm-13-1.5h13v-.85c0-.267-.08-.52-.238-.762a1.505 1.505 0 00-.587-.538c-1.067-.517-2.042-.87-2.925-1.062-.883-.192-1.8-.288-2.75-.288s-1.875.096-2.775.288c-.9.191-1.875.545-2.925 1.062a1.42 1.42 0 00-.575.538c-.15.241-.225.495-.225.762v.85zm6.5-8.025c.65 0 1.188-.212 1.613-.637.425-.425.637-.963.637-1.613s-.212-1.187-.637-1.612c-.425-.425-.963-.638-1.613-.638s-1.188.213-1.613.638c-.425.425-.637.962-.637 1.612 0 .65.212 1.188.637 1.613.425.425.963.637 1.613.637z"
                fill={props?.color ?? "#2D57D9"}
            />
        </Svg>
    )
}

export default UserInfo
